export const SET_SOIL_SAMPLES_DATA = "SET_SOIL_SAMPLES_DATA";
export const READ_GEO_SOIL_SAMPLES = "READ_GEO_SOIL_SAMPLES";
export const CLEAR_GEO_SOIL_SAMPLES = "CLEAR_GEO_SOIL_SAMPLES";
export const START_SOIL_SAMPLES_RELOAD = "START_SOIL_SAMPLES_RELOAD";
export const FINISHED_SOIL_SAMPLES_RELOAD = "FINISHED_SOIL_SAMPLES_RELOAD";
export const SOIL_SAMPLES_ERROR = "SOIL_SAMPLES_ERROR";
export const READ_SOIL_SAMPLE_DETAILS = "READ_SOIL_SAMPLE_DETAILS";
